import React, { useState } from 'react';
import { Clock, SubNav } from '../components/SharedComponents';
import BudgetTab from './BudgetTab';
import BudgetDiagram from './BudgetDiagram';
import BudgetRapport from './BudgetRapport';
import BokforingTab from './BokforingTab';
import OxceedTab from './OxceedTab';

// ── BUDGET — eget toppblock ───────────────────────────────────────
// Budgetmatris (inmatning/generator/versioner) + Diagram (presentation).
// Export till PNG/Excel/PDF sker via portalens vanliga kort-meny.
//
// Blocket kan delas ut utan adminbehörighet. Bokförings-fliken stannar hos
// admin: den visar hela resultaträkningen konto för konto och är ett annat
// förtroende än att få arbeta i budgetmatrisen.
export default function BudgetBlock({ isAdmin }) {
  const [sub, setSub] = useState('matris');
  const TABS = [
    { id: 'matris',    label: 'Budgetmatris' },
    { id: 'diagram',   label: 'Diagram' },
    { id: 'rapport',   label: 'Styrelserapport' },
    ...(isAdmin ? [{ id: 'bokforing', label: 'Bokföring' }] : []),
    // Sandbox för Oxceed-kopplingen: läser live ur Fortnox men skriver
    // ingenting. Ligger bredvid Bokföring eftersom det är samma modell —
    // skillnaden är bara om siffrorna kommer uppladdade eller hämtade.
    ...(isAdmin ? [{ id: 'oxceed', label: 'Oxceed' }] : []),
  ];
  return (
    <div className="screen">
      <div className="header header-budget">
        <div>
          <div className="header-title">Budget & prognos — koncernen</div>
          <div className="header-name">Budgetsystem</div>
        </div>
        <Clock />
      </div>
      <SubNav tabs={TABS} active={sub} onChange={setSub} />
      {sub === 'matris' && <BudgetTab isAdmin={isAdmin} />}
      {sub === 'diagram' && <BudgetDiagram />}
      {sub === 'rapport' && <BudgetRapport />}
      {sub === 'bokforing' && isAdmin && <BokforingTab />}
      {sub === 'oxceed' && isAdmin && <OxceedTab />}
    </div>
  );
}
